import React from 'react';
import styled from 'styled-components'
import {getCssSizeValue} from "@repo/utils";
import {BREAKPOINTS} from "../../../../../styles/themeSettings";


const Wrapper =styled.span`
    --size: ${getCssSizeValue(33, BREAKPOINTS.MOBILE)};
    position: relative;
    color: transparent;
    height: var(--size);
    pointer-events: none;
    display: block;
    border-radius: calc(var(--size) / 2);
    background-color: ${({theme}) => theme.colors.white};

    @media (min-width: ${({theme}) => theme?.breakpoints?.tablet || 768}px) {
        --size: ${getCssSizeValue(44, BREAKPOINTS.TABLET)};
    }


    @media (min-width: ${({theme}) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
        --size: ${getCssSizeValue(76, BREAKPOINTS.DESKTOP)};
`
const HiddenPill = ({ text = '' }) => {
    const hiddenText = [...Array(text.length)].reduce((prev) => `${prev}_`, '')
    return (
        <Wrapper>
            {hiddenText}
        </Wrapper>
    );
};

export default HiddenPill;
